// extracted by mini-css-extract-plugin
module.exports = {"iconAndTextGrouping":"ActivityChip_iconAndTextGrouping__3oEU9","iconStyle":"ActivityChip_iconStyle__29rZY","numberCircle":"ActivityChip_numberCircle__3CVmD"};